import EmblaCarousel from "embla-carousel";

const CarouselInit = () => {
    const setupDotBtns = (dotsArray, embla) => {
        dotsArray.forEach((dotNode, i) => {
            dotNode.addEventListener("click", () => embla.scrollTo(i), false);
        });
    };
    const generateDotBtns = (dots, embla) => {
        const template =
            document.getElementById("embla-dot-template").innerHTML;
        dots.innerHTML = embla
            .scrollSnapList()
            .reduce((acc) => acc + template, "");
        const generatedDots = [].slice.call(
            dots.querySelectorAll(".embla__dot")
        );
        generatedDots.forEach((d, i) => {
            d.setAttribute(
                "aria-label",
                `View slide ${i + 1} of ${generatedDots.length}`
            );
            d.setAttribute("aria-controls", `slide-${i + 1}`);
        });
        return generatedDots;
    };

    const selectDotBtn = (dotsArray, embla) => () => {
        const previous = embla.previousScrollSnap();
        const selected = embla.selectedScrollSnap();
        dotsArray[previous].classList.remove("is-selected");
        dotsArray[selected].classList.add("is-selected");
    };

    const carousel = document.getElementById("home-carousel");
    if (!carousel) return;

    const autoplay = (embla, interval) => {
        let timer = 0;

        const play = () => {
            stop();
            requestAnimationFrame(
                () => (timer = window.setTimeout(next, interval))
            );
        };

        const stop = () => {
            window.clearTimeout(timer);
            timer = 0;
        };

        const next = () => {
            if (embla.canScrollNext()) {
                embla.scrollNext();
            } else {
                embla.scrollTo(0);
            }
            play();
        };

        return { play, stop };
    };

    const embla = EmblaCarousel(carousel, {
        align: "center",
        loop: "true",
    });
    const dots = document.querySelector(".embla__dots");
    const dotsArray = generateDotBtns(dots, embla);
    const setSelectedDotBtn = selectDotBtn(dotsArray, embla);

    const handleChangeSlide = () => {
        const selected = embla.selectedScrollSnap();
        // Set aria-hidden for each slide, as well as making buttons focusable as appropriate
        embla.slideNodes().forEach((slide, i) => {
            slide.setAttribute(
                "aria-hidden",
                i === selected ? "false" : "true"
            );

            const btn = slide.querySelector(".btn");
            if (btn) {
                i === selected
                    ? btn.removeAttribute("tabindex")
                    : btn.setAttribute("tabindex", "-1");
            }
        });
    };

    const autoplayer = autoplay(embla, 7000);

    setupDotBtns(dotsArray, embla);

    embla.on("select", () => {
        setSelectedDotBtn();
        handleChangeSlide();
    });
    embla.on("init", () => {
        setSelectedDotBtn();
        autoplayer.play();
    });
    embla.on("pointerDown", autoplayer.stop);
};

export default CarouselInit;
